import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { UserService } from '../services/common';
import { CommonService } from '../services/common';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService,
    private myRoute: Router, private userService: UserService,
    private commonService: CommonService) {
  }

  /** allows valid user to navigate to given route
   * @param next ActivatedRouteSnapshot can also be used to traverse the router state tree.
   * @param state This is a tree of activated route snapshots.
   * @returns Wrong User Not Navigate In This Page
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | UrlTree {
    const requiredRoles = route?.data['roles'] as string[] || [];
    const userRoles = this.userService.getUserPermissions();

    if (!this.auth.loggedIn()) {
      // Store the return URL before redirecting to login
      this.commonService.setLocalStorageValue('returnUrl', state.url);
      this.myRoute.navigate(["developer"]);
      return false;
    }

    if (requiredRoles?.length === 0) {
      return true;
    }

    const hasPermission = requiredRoles?.some(role => userRoles?.includes(role));

    if (!hasPermission) {
      // createUrlTree will automatically redirect and clean up component lifecycle
      return this.myRoute.createUrlTree(['/unauthorized']);
    }
    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.canActivate(route, state); // ✅ call it, don’t return the reference
  }
}
